module.exports = __webpack_public_path__ + "static/media/infoUserInvite.ce57c3fc.svg";